module.exports = __webpack_public_path__ + "static/media/BPI_8089616_1_pdf.89344f43.pdf";